// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__13M7H","validationTips":"StatementDescriptor_validationTips__3xKI4"};